export enum SessionsListTestID {
  ScheduleSessionModal = 'SessionsListTestID.ScheduleSessionModal',
}

export enum sessionViews {
  Current = "This month's",
  Previous = 'Past',
  Upcoming = 'Upcoming',
}

export const NUM_SESSIONS_TO_LOAD = 50;

export const initialPaginationInfo = {
  hasNextPage: false,
  loadedCount: 0,
  pageCursor: '',
  totalCount: 0,
};
